export enum FrequenciaRecorrenciaEnum {
    Dia = 1,
    Semana = 2,
    Mes = 3,
    Ano = 4,
}
